import { DXR, Options } from '../../../common/devexpress/RichEdit/dx-richedit';

export function disablePrintAndDownload(options: Options) {
  const filePanel = options.ribbon.getTab(DXR.RibbonTabType.File)!;
  filePanel.removeItem(DXR.FileTabItemId.PrintDocument);
  filePanel.removeItem(DXR.FileTabItemId.Download);
}
